import { useQueryClient, UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { deleteClient } from '../api/client.api'
import { clientQueryKey } from './use-client'

/**
 * Deletes the API access client belonging to a user and invalidates the cached client on success.
 */
export const useDeleteClient = (userId: number | undefined, onSuccess?: () => void): UseMutationResult<void | null, Error, void> => {
  const authFetch = useAuthFetchWithResponse()
  const queryClient = useQueryClient()

  return usePortalMutation<void, Error, void>({
    mutationFn: () => deleteClient(userId, authFetch),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: clientQueryKey(userId) })
      onSuccess?.()
    },
  })
}
